class Nav {
	constructor () {
		console.log('Nav');

		this.$nav = $('body').find('> nav');
		this.$btnToggle = $('#btn_toggle_menu');

		let mql = window.matchMedia( "(min-width: 768px)" );
		mql.addListener(this.screenModeChange.bind(this));
		this.screenModeChange(mql);

		this.bindEvents();
	}

	bindEvents () {
		this.$btnToggle.on('click', this.toggleMenu.bind(this));
	}

	toggleMenu () {
		if(this.$nav.hasClass('visible'))
		{
			this.$nav.removeClass('visible');
		}
		else
		{
			this.$nav.addClass('visible');
		}
	}

	screenModeChange ( mql ) {
		console.log('screeModeChange');
		this.$nav.removeClass('visible');
		if ( mql.matches )
		{
			this.$btnToggle.attr("aria-hidden", "true");
		}
		else
		{
			this.$btnToggle.removeAttr("aria-hidden");
		}
	}
}

let $body = null;
let $html = null;

class Page {

	constructor () {
		console.log('Page');
		new Nav();

		$("#btn_back2top").on('click', function (e){
			e.preventDefault();
			Page.getBody().add(Page.getHtml()).animate({ scrollTop: 0 }, 'slow');
		});

	}

	static getBody () {
		if ( !$body )
		{
			$body = $('body');
		}
		return $body;
	}

	static getHtml () {
		if ( !$html )
		{
			$html = $('html');
		}
		return $html;
	}
}

class ProjectCarousel {
	constructor ( $container, options ) {
		console.log( 'ProjectCarousel', $container );
		this.$container = $container;
		this.options = options;

		this.create();

	}

	create () {

		this.$container.find('article').wrap("<div></div>");

		let slider = tns({
			container: this.$container[0],
			items: 1,
			slideBy: 1,
			autoplay: true,
			nav: false,
			autoplayButtonOutput: false,
			responsive: this.options
		});

	}
}

class Quotes {
	constructor () {
		this.$container = $('#quotes');
		if ( !this.$container )
		{
			return;
		}

		this.canClick = true;
		this.$quote = this.$container.find('blockquote');

		this.load();
	}

	bindEvents () {
		this.$container.find('button').on('click', this.nav.bind(this));
	}

	load () {
		$.ajax({
			url: BASE_URL + '_ajax/load_quote.php',
			type: 'post',
			dataType: 'json'
		}).done(this.init.bind(this));
	}

	init ( data ) {
		console.log('Quotes.init', data);

		this.quotes = data;
		this.current = 0;
		this.startSlideshow();

		gsap.set(this.$quote, { opacity: 0 });
		this.changeQuote( 0 );
		this.startSlideshow();
		this.bindEvents();
	}

	startSlideshow () {



	}

	stopSlideshow () {

	}

	nav ( e ) {
		if ( !this.canClick )
		{
			return false;
		}

		this.canClick = false;

		let $this = $(e.target);
		this.timeline.kill();
		gsap.to(this.$quote, { opacity: 0, onComplete: () => {
				this.changeQuote( this.current + parseInt($this.attr('data-dir')) );
			} });
	}

	changeQuote ( nextId ) {
		if ( nextId < 0 )
		{
			nextId = this.quotes.length - 1;
		}
		else if ( nextId >= this.quotes.length )
		{
			nextId = 0;
		}

		this.current = nextId;

		this.$quote.html('«&nbsp;' + this.quotes[this.current] + '&nbsp;»' );

		this.timeline = gsap.timeline({ onComplete: () => { this.changeQuote(this.current + 1); } });
		this.timeline.to(this.$quote, { opacity: 1, duration: .2, onComplete: () => { this.canClick = true; } });
		this.timeline.to(this.$quote, { opacity: 0, duration: .2, delay: 5, onStart: () => { this.canClick = false; } });
	}
}

class PageHome extends Page {

	constructor () {
		super();

		let carouselResponsiveConfig = {
			580: {
				items: 2,
			},
			768: {
				items: 1,
			},
			970: {
				items: 2,
			},
			1330: {
				items: 3,
			},
			1720: {
				items: 4,
			}
		};

		if ( LANG !== 'fr' )
		{
			carouselResponsiveConfig = {
				580: {
					items: 2,
				},
				940: {
					items: 3,
				},
				1200: {
					items: 4,
				},
				1600: {
					items: 5,
				},
				1800: {
					items: 6,
				}
			};
		}


		new ProjectCarousel( $('#project_list').find('div.project_list'), carouselResponsiveConfig );

		new Quotes();

	}

}

class PageProjectList extends Page {
	constructor () {
		super();
		console.log('PageProjectList');

		this.viewIncrement = 4;
		this.currentHiddenCount = 0;

		this.$container = $('#project_list').find('div.project_list');
		this.$articles = this.$container.find('article');


		this.mediaQueries = {
			xsmall: {		// 1 item
				mql: window.matchMedia("(min-width: 0px) and (max-width: 589px)"),
				increment: 6
			},
			small: {		// 2 items
				mql: window.matchMedia("(min-width: 590px) and (max-width: 909px)"),
				increment: 8
			},
			medium: {		// 3 items
				mql: window.matchMedia("(min-width: 910px) and (max-width: 1229px)"),
				increment: 9
			},
			large: {		// 4 items
				mql: window.matchMedia("(min-width: 1230px) and (max-width: 1549px)"),
				increment: 12
			},
			xlarge: {		// 5 items
				mql: window.matchMedia("(min-width: 1550px) and (max-width: 1869px)"),
				increment: 15
			},
			xxlarge: {		// 6 items
				mql: window.matchMedia("(min-width: 1870px)"),
				increment: 18
			},
		};

		for ( let mqlSize in this.mediaQueries )
		{
			this.mediaQueries[mqlSize].mql.addListener(( mql ) => { this.mediaQueryChange( mql ); });
		}

		this.initMasonry();
		this.mediaQueryChange( null );


		$("#btn_view_more_projects").on('click', () => {
			console.log('view more');
			this.currentHiddenCount += this.viewIncrement;
			this.showContent();
			if ( this.$container.find('article:last').is(':visible') )
			{
				$("#btn_view_more_projects").parents('p.more_projects').hide();
			}
		});

		setTimeout(() => {
			if ( this.$container.find('article:last').is(':visible') )
			{
				$("#btn_view_more_projects").parents('p.more_projects').hide();
			}
		}, 500);

	}

	mediaQueryChange ( mql ) {
		console.log('mediaQueryChange!');
		for ( let mqlSize in this.mediaQueries )
		{
			if (this.mediaQueries[mqlSize].mql.matches )
			{
				console.log('on a un match!', mqlSize);
				this.viewIncrement = this.mediaQueries[mqlSize].increment;
				this.reset();
				this.showContent();
			}
		}
	}

	reset () {
		this.currentHiddenCount = 0;
		TweenMax.set(this.$articles, { opacity: 0 });
		this.$articles.hide();
	}

	initMasonry () {
		console.log('initMasonry');
		this.msnry = new Masonry( this.$container[0], {
			columnWidth: 270,
			itemSelector: 'article',
			gutter: 50,
			isFitWidth: true,
			transitionDuration: 0
		} );
		imagesLoaded ( this.$container[0], () => {
			console.log('images loaded');
			this.msnry.layout();
		} );
	}

	showContent () {
		let $newArticles = this.$articles.slice( this.currentHiddenCount, this.currentHiddenCount + this.viewIncrement );
		let currentHeight = this.$container.height();
		let $window = $(window);
		let currentScrollTop = $window.scrollTop();


		console.log(currentScrollTop);

		$newArticles.show();
		this.msnry.layout();



		let newHeight = this.$container.height();

		let tl = new TimelineMax();
		tl.fromTo(this.$container, .5, { height: currentHeight }, { height: newHeight, onUpdate: () => { $window.scrollTop( currentScrollTop ); } });
		tl.fromTo( $newArticles, .5, { opacity: 0 }, { opacity: 1, onUpdate: () => { $window.scrollTop( currentScrollTop ); } } );
	}
}

class PageTeam extends Page {
	constructor () {
		super();


		let $images = $('#team_members').find('article img');
		$images.each(function(){
			let $this = $(this);
			let img = new Image();
			let strImage = $this.attr('data-animated');

			img.onload = function(e){
				$images.filter('[data-animated="' + e.target.src + '"]').attr('src', e.target.src);
			};
			img.src = strImage;

		});

	}

}

class ItemList {
	constructor ( options ) {

		this.options = options;

		if ( !this.options.hasOwnProperty("container") )
		{
			console.log( 'ItemList - Missing container option' );
			return false;
		}

		if ( !this.options.hasOwnProperty("itemSelector") )
		{
			console.log( 'ItemList - Missing itemSelector option' );
			return false;
		}

		if ( !this.options.hasOwnProperty("btnId") )
		{
			console.log( 'ItemList - Missing btnId option' );
			return false;
		}

		this.$container = this.options.container;
		this.$articles = this.$container.find(this.options.itemSelector);
		this.$btnViewMore = $("#" + this.options.btnId);

		this.mediaQueries = {
			xsmall: {		// 1 item
				mql: window.matchMedia("(min-width: 0px) and (max-width: 589px)"),
				increment: 6
			},
			small: {		// 2 items
				mql: window.matchMedia("(min-width: 590px) and (max-width: 909px)"),
				increment: 8
			},
			medium: {		// 3 items
				mql: window.matchMedia("(min-width: 910px) and (max-width: 1229px)"),
				increment: 9
			},
			large: {		// 4 items
				mql: window.matchMedia("(min-width: 1230px) and (max-width: 1549px)"),
				increment: 12
			},
			xlarge: {		// 5 items
				mql: window.matchMedia("(min-width: 1550px) and (max-width: 1869px)"),
				increment: 15
			},
			xxlarge: {		// 6 items
				mql: window.matchMedia("(min-width: 1870px)"),
				increment: 18
			},
		};

		for ( let mqlSize in this.mediaQueries )
		{
			this.mediaQueries[mqlSize].mql.addListener(( mql ) => { this.mediaQueryChange( mql ); });
		}

		this.mediaQueryChange( null );

		this.bindEvents();
	}

	bindEvents () {

		this.$btnViewMore.on('click', () => {
			console.log('view more');
			this.currentHiddenCount += this.viewIncrement;
			this.showContent();
		});

	}

	mediaQueryChange ( mql ) {
		console.log('mediaQueryChange!');
		for ( let mqlSize in this.mediaQueries )
		{
			if (this.mediaQueries[mqlSize].mql.matches )
			{
				console.log('on a un match!', mqlSize);
				this.viewIncrement = this.mediaQueries[mqlSize].increment;
				this.reset();
				this.showContent();
			}
		}
	}

	reset () {
		this.currentHiddenCount = 0;
		TweenMax.set(this.$articles, { opacity: 0 });
		this.$articles.hide();
		this.$btnViewMore.show();
		if ( this.options.hasOwnProperty("onReset") )
		{
			this.options.onReset();
		}
	}

	showContent () {
		let $newArticles = this.$articles.slice( this.currentHiddenCount, this.currentHiddenCount + this.viewIncrement );
		let currentHeight = this.$container.height();

		$newArticles.show();
		this.$container.css({ 'height': 'auto' });

		if ( this.options.hasOwnProperty("onChange") )
		{
			this.options.onChange();
		}

		let newHeight = this.$container.height();

		console.log('currentHeight', currentHeight);
		console.log('newHeight', newHeight);

		let tl = new TimelineMax();
		tl.fromTo(this.$container, .5, { height: currentHeight }, { height: newHeight });
		tl.fromTo( $newArticles, .5, { opacity: 0 }, { opacity: 1 } );

		if ( this.$articles.filter(':hidden').length == 0 )
		{
			this.$btnViewMore.hide();
		}
	}

}

class PageClients extends Page{
	constructor () {
		super();
		console.log('PageClients');

		this.$container = $('#client_list').find('div.client_list');
		this.$articles = this.$container.find('article');
		this.$projectList = $('#project_list');
		this.$projectListContent = this.$projectList.find('.project_list_wrap');
		this.$btnViewMore = $('#btn_view_more_clients');


		this.isAnimating = false;
		this.isLoading = false;
		this.contentReady = false;
		this.animReady = false;

		this.minimumLoadingTime = 1500;
		this.startLoadingTime = 0;

		this.projectContent = "";


		this.canClick = true;

		this.bindEvents();

		TweenMax.set(this.$projectList, {});

		new ItemList({
			btnId: 'btn_view_more_clients',
			container: this.$container,
			itemSelector: 'article',
			onReset: () => { this.closeProjects( this.$articles.filter('.active') ); }
		});
	}

	bindEvents () {
		this.$articles.find('button').on('click', this.clickClient.bind(this));
	}

	clickClient (e) {
		let $article = $(e.target).parents('article');
		console.log('clickClient', $article);

		if(this.isAnimating || this.isLoading)
		{
			return false;
		}

		if ( $article.hasClass('active') )
		{
			this.closeProjects( $article );
		}
		else if ( this.$articles.filter('.active').length > 0 )
		{
			this.closeProjects( this.$articles.filter('.active'), () => {this.openProjects( $article );} );
		}
		else
		{
			this.openProjects( $article );
		}
	}

	openProjects ( $article ) {
		console.log('openProjects');

		let currentTop = $article.offset().top;
		let $testArticle = $article.next("article");

		this.$container.css({ 'height': 'auto' });

		while ( $testArticle.length > 0 && $testArticle.offset().top == currentTop )
		{
			console.log('while');
			$testArticle = $testArticle.next("article");
			if ( !$testArticle )
			{
				console.log('break!');
				break;
			}
		}

		if ( $testArticle.length > 0 )
		{
			this.$projectList.insertBefore($testArticle);
		}
		else
		{
			this.$projectList.insertAfter(this.$articles.filter(":last"));
		}

		this.contentReady = false;
		this.animReady = false;
		this.isLoading = true;
		this.startLoadingTime = (new Date()).getTime();

		$.ajax({
			url: BASE_URL + '_ajax/load_client_projects.php',
			type: 'GET',
			data: 'id=' + $article.attr('data-client-id'),
			dataType: 'html'
		}).done((data) => {
			console.log('project ajax done');
			this.projectContent = data;
			this.contentReady = true;
			this.displayProjects();
		});
		$article.addClass('active');

		this.isAnimating = true;
		let tl = new TimelineMax();
		tl.fromTo(this.$projectList, .2, { marginTop: 0, marginBottom: 0 }, { marginTop: 25, marginBottom: 25 });
		tl.fromTo(this.$projectList, .5, { height: 0 }, { height: 270, onComplete: () => {
				this.$projectList.addClass('loading');
				this.isAnimating = false;
				this.animReady = true;
				this.displayProjects();
			} });
	}

	closeProjects ( $article, callback ) {
		console.log('closeProjects');
		callback = callback || null;

		$article.removeClass('active');

		this.$projectList.removeClass('loading');

		this.isAnimating = true;
		let tl = new TimelineMax();
		tl.to(this.$projectList, .2, { marginTop: 0, marginBottom: 0 });
		tl.to(this.$projectList, .5, { height: 0, onComplete: () => {
				this.isAnimating = false;
				this.$projectList.insertAfter(this.$articles.filter(":last"));
				this.$projectListContent.html("");
				if ( typeof callback === "function" )
				{
					callback();
				}
			} });

	}

	displayProjects () {
		console.log('displayProjects');
		console.log('contentReady', this.contentReady);
		console.log('animReady', this.animReady);

		if ( this.contentReady && this.animReady )
		{
			console.log('do it');

			let currentTime = (new Date()).getTime();
			let delta = this.startLoadingTime - currentTime;
			let delay = (delta < this.minimumLoadingTime) ? (this.minimumLoadingTime - delta) : 0;

			setTimeout(() => {

				this.$projectList.removeClass('loading');
				this.$projectListContent.html(this.projectContent);
				new ProjectCarousel( this.$projectListContent.find('.project_list'), {
					580: {
						items: 2,
					},
					960: {
						items: 3,
					},
					1200: {
						items: 4,
					},
					1600: {
						items: 5,
					},

				} );
				TweenMax.set(this.$projectList, { height: "auto" });
				let tl = new TimelineMax();
				tl.from(this.$projectList, .2, { height: 270 });
				tl.from( this.$projectListContent, .2, { opacity: 0 } );
				tl.set(this.$projectList, { height: "auto" });
				this.isLoading = false;

			}, delay);

		}
	}

}

class Maps {


	constructor ( _strHtmlId, _numInitLatitude, _numInitLongitude, _iZoom ) {

		console.log('Maps constructor');


		this.resetDefaultValues();
		let objInitialCoord = new google.maps.LatLng( _numInitLatitude, _numInitLongitude );
		let arrStyles = [];
		if(arguments.length > 4)
		{
			arrStyles = arguments[4];
		}
		this.m_jsnStyledMaps = new google.maps.StyledMapType(arrStyles, {name:"PLA"});
		this.m_objGoogleMaps = new google.maps.Map(document.getElementById(_strHtmlId), {
			zoom: _iZoom,
			center: objInitialCoord,
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			streetViewControl: false,
			disableDefaultUI: true
		});
		this.m_objGoogleMaps.mapTypes.set('map_style', this.m_jsnStyledMaps);
		this.m_objGoogleMaps.setMapTypeId('map_style');

	}

	resetDefaultValues () {
		this.m_objGoogleMaps = null;
		this.m_jsnImageInfo = {};
		this.m_jsnMarkerShape = {};
		this.m_jsnStyledMaps = null;
		this.m_arrMarkers = [];
	}

	addAffranchisMarker () {
		let objMarker = new google.maps.Marker({
			position: new google.maps.LatLng("45.527327", "-73.576456"),
			map: this.m_objGoogleMaps,
			icon: {
				url: BASE_URL + '_/images/contact_map_icon.png',
				size: new google.maps.Size(51, 61),
				scaledSize: new google.maps.Size(51, 61),
				origin: new google.maps.Point(0, 0)
			},
			shape: {
				coord: [1, 1, 51, 62],
				type: 'rect'
			},
			title: 'lesAffranchis'
		});
	};

}


// var PLA = PLA || {};

/**
 * PLA.Maps
 * Google Maps API wrapper
 * @param	string	id of html container
 * @param	float	latitude of starting position
 * @param	float	longitude of starting position
 * @param	array	(optional) google map style array
 *						[
 *							{ featureType: "landscape", stylers: [ { color: '#aaffff' } ] },
 *							{ featureType: "natural", stylers: [ { hue: '#ff0000' } ] },
 *							{ featureType: "road", stylers: [ { hue: '#5500aa' }, { saturation: -70 } ] },
 *							{ featureType: "building", elementType: "labels", stylers: [ { hue: '#000066' } ] },
 *							{ featureType: "poi", stylers: [ { hue: '#0044ff' } ] }
 *						]
 **/
// PLA.Maps = function( _strHtmlId, _numInitLatitude, _numInitLongitude, _iZoom){
// 	this.resetDefaultValues();
// 	var objInitialCoord = new google.maps.LatLng(_numInitLatitude, _numInitLongitude),
// 		arrStyles = [];
// 	if(arguments.length > 4)
// 	{
// 		arrStyles = arguments[4];
// 	}
// 	this.m_jsnStyledMaps = new google.maps.StyledMapType(arrStyles, {name:"PLA"});
// 	this.m_objGoogleMaps = new google.maps.Map(document.getElementById(_strHtmlId), {
// 		zoom: _iZoom,
// 		center: objInitialCoord,
// 		mapTypeId: google.maps.MapTypeId.ROADMAP,
// 		streetViewControl: false,
// 		disableDefaultUI: true
// 	});
// 	this.m_objGoogleMaps.mapTypes.set('map_style', this.m_jsnStyledMaps);
// 	this.m_objGoogleMaps.setMapTypeId('map_style');
// };

/**
 * PLA.Maps properties
 **/
// PLA.Maps.prototype = {
// 	m_objGoogleMaps: null,
// 	m_jsnImageInfo: {},
// 	m_jsnMarkerShape: {},
// 	m_jsnStyledMaps: null,
// 	m_arrMarkers: []
// };

/**
 * PLA.Maps.resetDefaultValues()
 * Reset default values
 **/
// PLA.Maps.prototype.resetDefaultValues = function() {
// 	this.m_objGoogleMaps = null;
// 	this.m_jsnImageInfo = {};
// 	this.m_jsnMarkerShape = {};
// 	this.m_jsnStyledMaps = null;
// 	this.m_arrMarkers = [];
// };

/**
 * PLA.Maps.setDefaultMarker()
 * Set default params for Marker
 * @param	string	image url
 * @param	int		image width in px
 * @param	int		image height in px
 * @param	json	(optional - default is rect) link shape json { coord: [1, 1, 22, 26], type: 'rect' }
 **/
// PLA.Maps.prototype.setDefaultMarker = function(_strImageUrl, _iImageWidth, _iImageHeight) {
//
// 	this.m_jsnImageInfo = {
// 		url: _strImageUrl,
// 		size: new google.maps.Size(_iImageWidth, _iImageHeight),
// 		origin: new google.maps.Point(0, 0),
// 		anchor: new google.maps.Point(0, _iImageHeight)
// 	};
// 	this.m_jsnMarkerShape = {
// 		coord: [1, 1, _iImageWidth, _iImageHeight],
// 		type: 'rect'
// 	};
// 	if(arguments.length > 3)
// 	{
// 		this.m_jsnMarkerShape = arguments[3];
// 	}
// };

// PLA.Maps.prototype.addAffranchisMarker = function(){
// 	var objMarker = new google.maps.Marker({
// 		position: new google.maps.LatLng("45.527327", "-73.576456"),
// 		map: this.m_objGoogleMaps,
// 		icon: {
// 			url: BASE_URL + '_/images/contact_map_icon.png',
// 			size: new google.maps.Size(51, 61),
// 			scaledSize: new google.maps.Size(51, 61),
// 			origin: new google.maps.Point(0, 0)
// 		},
// 		shape: {
// 			coord: [1, 1, 51, 62],
// 			type: 'rect'
// 		},
// 		title: 'lesAffranchis'
// 	});
// };

/**
 * PLA.Maps.addMarker()
 * Add a marker on the map
 * @param	json	place json {"name": "Les Affranchis", "lat": "45.527339", "long": "-73.576405", "content": "<div>Les affranchis étaient ici!</div>" }
 * @param	string	force new marker url (optional)
 **/
// PLA.Maps.prototype.addMarker = function() {
// 	var jsnPlace = arguments[0],
// 		objCoord = new google.maps.LatLng(jsnPlace.lat, jsnPlace.long),
// 		jsnIcon = this.m_jsnImageInfo,
// 		objMarker;
// 	if(arguments.length > 1)
// 	{
// 		jsnIcon = {
// 			url: arguments[1],
// 			size: this.m_jsnImageInfo.size,
// 			origin: this.m_jsnImageInfo.origin,
// 			anchor: this.m_jsnImageInfo.anchor
// 		};
// 	}
// 	objMarker = new google.maps.Marker({
// 		position: objCoord,
// 		map: this.m_objGoogleMaps,
// 		icon: jsnIcon,
// 		shape: this.m_jsnMarkerShape,
// 		title: jsnPlace.name,
// 		desc: jsnPlace.content
// 	});
// 	google.maps.event.addListener(objMarker, 'click', function(e) {
// 		var infowindow = new google.maps.InfoWindow({
// 			content: jsnPlace.content
// 		});
// 		infowindow.open(objMarker.map, this);
// 	});
// 	this.m_arrMarkers.push(objCoord);
// };

/**
 * PLA.Maps.zoomToShow()
 * Adjust view to see all markers
 **/
// PLA.Maps.prototype.zoomToShow = function() {
// 	var objMapBounds = new google.maps.LatLngBounds (),
// 		iMarkerCount = this.m_arrMarkers.length;
// 	for (var i = 0; i < iMarkerCount; i++) {
// 		objMapBounds.extend (this.m_arrMarkers[i]);
// 	}
// 	this.m_objGoogleMaps.fitBounds(objMapBounds);
// };

/**
 * PLA.Maps.geoCoder
 * Google Maps GeoCoder API wrapper
 **/
// PLA.Maps.geoCoder = function(){
// 	this.m_objGeoCoder = new google.maps.Geocoder();
// };

/**
 * PLA.Maps.geoCoder properties
 **/
// PLA.Maps.geoCoder.prototype = {
// 	m_objGeoCoder: null
// };

/**
 * PLA.Maps.geoCoder.codeAddress()
 * Get latitude and longitude from address string
 **/
// PLA.Maps.geoCoder.prototype.codeAddress = function(_strAddress, callback) {
// 	this.m_objGeoCoder.geocode(
// 		{ 'address': _strAddress},
// 		function(results, status) {
// 			if (status == google.maps.GeocoderStatus.OK) {
// 				var coords = {
// 					"lat": results[0].geometry.location.lat(),
// 					"long": results[0].geometry.location.lng()
// 				};
// 			} else {
// 				var coords = {"error": status};
// 			}
// 			callback(coords);
// 		}
// 	);
// };

class PageContact extends Page {

	constructor() {
		super();

		console.log('contact');

		this.$maps = $('#map');
		this.$main = $('#main');
		this.$nav = $('body').find('> nav');
		this.maps = null;

		console.log('HELLO');

		this.resize();
		//this.createMap();
		
		this.btnSubmit = document.querySelector('#btn_submit');
		
		this.btnSubmit.addEventListener('click', (e) =>
		{
			e.preventDefault();
			console.log('submit', e);
			
			this.btnSubmit.style.display = 'none';
			
			let form = document.querySelector('#frmContact');
			
			var formData = new FormData(form);
			
			// Convert FormData to JSON object
			var formObject = {};
			formData.forEach((value, key) => {
				formObject[key] = value;
			});
			
			let arrInput = Array.from(form.querySelectorAll('.text-error'));
			
			for (let i = 0; i < arrInput.length; i++)
			{
				let input = arrInput[i];
				input.classList.add('hide');
			}
			
			let lang = formObject["lang"];
			
			fetch('/' + lang + '/endpoints/contact/submit', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(formObject)
			})
				.then(response => response.json())
				.then(data => {
					
					console.log(data);
					console.log(data.status);
					
					
					
					
					
					if (data.status == "success")
					{
						form.style.display = 'none';
						
						let formLabel = document.querySelector('#form_label');
						formLabel.style.display = 'none';
						
						let formSuccess = document.querySelector('#form_success');
						formSuccess.classList.remove('hide');

						gtag('event', 'conversion', {'send_to': 'AW-1019860243/FfdyCL71jtcZEJOqp-YD'});
						console.log('Sending gtag conversion');
					}
					else
					{
						
						let errors = data.errors;
						
						for (let error in errors)
						{
							let message = errors[error];
							let field = document.querySelector(`#error_${error}`);
							
							field.innerText = message;
							field.classList.remove('hide');
						}
						
						this.btnSubmit.style.display = 'inline-block';
					}
				})
				.catch((error) => {
					console.error('Error submitting form:', error);
				});
			
			console.log(formObject);
		
		});

		$(window).on('resize.affranchis', () => { this.resize(); });

	}

	resize (_iWidth) {

		// this.$maps.height( parseInt(this.$main.css('padding-top')) - this.$nav.outerHeight() );
		//
		// this.destroyMap();
		// if(window.matchMedia('(min-width: 768px)').matches)
		// {
		// 	this.createMap();
		// }
	}

	createMap () {

		this.maps = new Maps(this.$maps.attr('id'), "45.527339", "-73.576405", 16, MapStyle);
		// this.maps = new PLA.Maps(this.$maps.attr('id'), "45.527339", "-73.576405", 16, MapStyle); // TODO convertir PLA.Maps en code moderne pour que ça refonctionne
		this.maps.addAffranchisMarker();
	}

	destroyMap () {
		if(this.maps)
		{
			this.maps.resetDefaultValues();
			this.$maps.empty();
		}
	}


}



const MapStyle = [
	{
		"elementType": "geometry.fill",
		"stylers": [
			{ "color": "#eaeaea" }
		]
	},{
		"featureType": "water",
		"stylers": [
			{ "visibility": "on" },
			{ "color": "#d1d1d1" }
		]
	},{
		"featureType": "landscape",
		"stylers": [
			{ "visibility": "on" },
			{ "color": "#eaeaea" }
		]
	},{
		"featureType": "poi",
		"stylers": [
			{ "visibility": "off" }
		]
	},{
		"featureType": "road",
		"elementType": "geometry.fill",
		"stylers": [
			{ "visibility": "on" },
			{ "color": "#ffffff" }
		]
	},{
		"featureType": "road",
		"elementType": "geometry.stroke",
		"stylers": [
			{ "visibility": "on" },
			{ "color": "#bfbfbf" }
		]
	},{
		"featureType": "road",
		"elementType": "labels.text.fill",
		"stylers": [
			{ "visibility": "on" },
			{ "color": "#979797" }
		]
	},{
		"featureType": "road",
		"elementType": "labels.text.stroke",
		"stylers": [
			{ "visibility": "on" },
			{ "color": "#ffffff" }
		]
	},{
		"featureType": "road",
		"elementType": "labels.icon",
		"stylers": [
			{ "color": "#808080" },
			{ "visibility": "off" }
		]
	},{
		"featureType": "transit.station",
		"elementType": "labels.icon",
		"stylers": [
			{ "visibility": "on" },
			{ "hue": "#ff0000" },
			{ "saturation": -100 },
			{ "lightness": -4 }
		]
	},{
		"featureType": "transit.station",
		"elementType": "labels.text",
		"stylers": [
			{ "lightness": 22 }
		]
	},{
		"featureType": "administrative",
		"elementType": "labels.text.fill",
		"stylers": [
			{ "color": "#979797" }
		]
	},{
		"featureType": "administrative",
		"elementType": "labels.text.stroke",
		"stylers": [
			{ "color": "#ffffff" }
		]
	},{
		"featureType": "transit.line",
		"stylers": [
			{ "visibility": "off" }
		]
	},{
		// "featureType": "transit.station.airport",
		"featureType": "transit.station",
		"stylers": [
			{ "visibility": "on" },
			{ "saturation": -100 },
			{ "hue": "#ff0055" },
			{ "lightness": 40 }
		]
	},{
		"featureType": "administrative",
		"elementType": "geometry.fill",
		"stylers": [
			{ "visibility": "on" },
			{ "color": "#ededed" }
		]
	}
];

class Main
{
	constructor ()
	{

		switch ( (Page.getBody()).attr('id') )
		{
			case 'home':
				new PageHome();
				break;
			case 'projects':
				new PageProjectList();
				break;
			case 'team':
				new PageTeam();
				break;
			case 'clients':
				new PageClients();
				break;
			case 'contact':
				new PageContact();
				break;
			
			case 'landing':
				 new PageProjectList();
				new PageContact();
				break;
			default:
				new Page();
				break;
		}

	}
}

$(function () {
	new Main();
});
